/**
 * App Bridge Loading Hook
 * Controls the App Bridge loading indicator
 */

import { useEffect } from 'react';
import { useAppBridge } from './useAppBridge';

export function useLoading(isLoading: boolean) {
  const { appBridge, isLoading: isAppBridgeLoading } = useAppBridge();

  useEffect(() => {
    // Wait for App Bridge to be ready before attempting to control loading state
    if (isAppBridgeLoading || !appBridge) {
      return;
    }

    // Now safe to call loading API
    if (isLoading) {
      appBridge.loading(true);
    } else {
      appBridge.loading(false);
    }

    // Cleanup: ensure loading is stopped when component unmounts
    return () => {
      if (appBridge) {
        appBridge.loading(false);
      }
    };
  }, [isLoading, appBridge, isAppBridgeLoading]);
}
